<template>
  <div class="contact">
    <div class="section" :class="$mq">
      <div class="contact-info">
        <h1>Kontaktní informace</h1>
        <div class="contacts">
          <p><strong>ČESKÝ PRODUKT s. r. o.</strong></p>
          <p>IČO: 05748232</p>
          <p>DIČ: CZ05748232</p>
        </div>
        <div class="contacts">
          <p><img src="../assets/icon-home.png"/><span class="padded-text">Vícenice 157<br>675 71&nbsp;&nbsp;Náměšť nad Oslavou</span></p>
          <p><img src="../assets/icon-phone.png"/>+420 606 600 010</p>
          <p><img src="../assets/icon-mail.png"/>info@brambory.cz</p>
        </div>
        <p class="quote hide"><strong>ČESKÝ PRODUKT s.r.o.</strong><br/>Vícenice 56<br/>Náměšť nad Oslavou<br/>675 71<br/>Česká republika<br/><br/>IČ: 05748232</p>
      </div>
      <div class="contact-form">
        <h1>Napište nám!</h1>

        <p v-if="error" class="error">{{ error }}</p>
        <p v-if="responseMessage" class="success">{{ responseMessage }}</p>

        <form @submit="checkForm">
          <div class="form-row">
            <label for="field-name" class="required">Jméno: *</label>
            <input type="text" id="field-name" v-model="message.senderName"/>
          </div>
          <div class="form-row">
            <label for="field-phone">Telefon:</label>
            <input type="text" id="field-phone" v-model="message.senderPhone"/>
          </div>
          <div class="form-row">
            <label for="field-email" class="required">E-mail: *</label>
            <input type="text" id="field-email" v-model="message.senderEmail"/>
          </div>
          <div class="form-row">
            <label for="field-message" class="required">Zpráva: *</label>
            <textarea id="field-message" rows="5" v-model="message.messageText"></textarea>
          </div>
          <div class="form-row">
            <vue-recaptcha sitekey="6LdcYLQUAAAAABgdbu950EFNvaGAfxL-4A92RaE4">
              <button>ODESLAT</button>
            </vue-recaptcha>
          </div>
        </form>
      </div>
    </div>
    <div class="section hide">
      <GmapMap
        :center="{lat:49.201588, lng:16.129756}"
        :zoom="14"
        id="map"
      >
        <GmapMarker
          :position="{lat:49.201588, lng:16.129756}"
          :clickable="true"
          @click="center=m.position"
        />
      </GmapMap>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import VueRecaptcha from 'vue-recaptcha'

export default {
  data () {
    return {
      message: {
        senderName: null,
        senderPhone: null,
        senderEmail: null,
        messageText: null
      },
      error: '',
      responseMessage: ''
    }
  },

  methods: {
    checkForm: function (e) {
      this.error = ''
      this.responseMessage = ''

      const messageBody = `
        <strong>Jméno:</strong> ${this.message.senderName}<br>
        <strong>Telefon:</strong> ${this.message.senderPhone}<br>
        <strong>Email:</strong> ${this.message.senderEmail}<br><br>
        <strong>Zpráva:</strong> <br> ${this.message.messageText}
      `

      const formattedBody = {
        personalizations: [
          {
            to: [
              {
                email: 'info@brambory.cz'
              }
            ],
            subject: 'Nová zpráva z webu brambory.cz'
          }
        ],
        from: {
          email: this.message.senderEmail,
          name: this.message.senderName
        },
        content: [
          {
            type: 'text/html',
            value: messageBody
          }
        ]
      }

      if (this.message.senderEmail && this.message.messageText && this.message.senderName) {
        axios.post(`https://cors-anywhere.herokuapp.com/https://api.sendgrid.com/v3/mail/send`, formattedBody, {
          headers: {
            Authorization: 'Bearer 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',
            'Content-Type': 'application/json'
          }
        }).then(response => {
          this.responseMessage = 'Zpráva byla úspěšně odeslána.'
        }).catch(e => {
          this.error = 'Zprávu se nepodařilo odeslat, zkuste to prosím znovu.'
        })
      } else {
        this.error = 'Zkontrolujte, jestli jste vyplnil(a) všechna povinná pole.'
      }

      e.preventDefault()
    }
  },

  components: {
    VueRecaptcha
  }
}
</script>

<style lang="scss" scoped>
.hide {
  display: none;
}

.contact {
  padding: 20px;

  &.mobile {
    padding: 10px;
  }

  .section {
    padding: 10px;
    width: 900px;

    &.mobile {
      width: auto;
      display: flex;
      flex-direction: column;

      .contact-info {
        width: auto;
        padding-right: 0;
      }

      .contact-form {
        width: auto;
        display: flex;
        flex-direction: column;
        padding: 0;
        border: 0;

        .form-row {
          display: flex;
          flex-direction: column;

          textarea {
            width: auto;
          }

          input {
            width: auto;
          }
        }
      }
    }

    h1 {
      font-size: 28px;
      line-height: 32px;
      padding: 10px 0 30px 0;
      color: rgb(0, 136, 16);;
    }

    #map {
      width: 100%;
      height: 400px;
      margin-top: 30px;
    }
  }

  .contact-info {
    display: inline-block;
    width: 370px;
    padding-right: 30px;
    vertical-align: top;

    p {
      line-height: 26px;
      padding-bottom: 5px;
      padding-top: 5px;

      &.quote {
        padding-left: 20px;
        border-left: 3px solid #ddd;
        margin-top: 35px;
      }

      strong {
        font-weight: 800;
      }
    }

    .contacts {
      padding: 10px 20px;
      margin-bottom: 20px;
      background: #eee;

      p {
        padding-top: 5px;
        padding-bottom: 5px;
        font-size: 18px;
        display: flex;

        span.padded-text {
          display: inline-block;
        }
      }

      img {
        margin-right: 20px;
        align-self: center;
      }
    }
  }

  .contact-form {
    display: inline-block;
    width: 440px;
    padding-left: 30px;
    vertical-align: top;
    border-left: 1px solid #ddd;

    .error {
      padding: 15px 20px;
      background: rgb(255, 198, 198);
      color: darkred;
      margin-bottom: 20px;
    }

    .success {
      padding: 15px 20px;
      background: rgb(214, 255, 190);
      color: rgb(0, 139, 12);
      margin-bottom: 20px;
    }

    .form-row {
      label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;

        &.required {
          font-weight: 800;
        }
      }

      input, textarea {
        margin-bottom: 15px;
        border: 1px solid #ddd;
        padding: 10px;
        font-family: inherit;
      }

      input {
        width: 250px;
      }

      textarea {
        width: 100%;
      }

      button {
        padding: 10px 20px;
        background: orangered;
        color: #fff;
        border: 0;
        margin-top: 5px;
        cursor: pointer;
        font-family: inherit;
        font-weight: bold;

        &:hover {
          background: brown;
        }
      }
    }
  }
}
</style>
